export default __webpack_public_path__ + "static/media/customise.66448761.svg";